import { Component, inject, input } from "@angular/core";
import { Button } from "common/data/data-view.component";
import { DialogAdapter } from "common/dialog/dialog-adapter";
import { NewDialogComponent } from "common/newdialog/dialog.component";
import { ButtonsBottomComponent } from "common/buttons/buttons-bottom.component";

import { TranslateModule } from "@ngx-translate/core";

@Component({
	selector: "stages-popup-footer",
	templateUrl: "./popup-footer.component.html",
	styleUrls: ["./popup-footer.component.scss"],
	imports: [ButtonsBottomComponent, TranslateModule],
})
export class PopupFooterComponent {
	private dialog = inject(DialogAdapter);

	readonly tabIndexOffset = input<number>(10);

	readonly buttons = input<Button[]>([]);

	readonly hasCancelButton = input<boolean>(true);

	readonly removeMargin = input<boolean>(true);

	readonly viewedDialog = input<NewDialogComponent>();

	close(): void {
		const viewedDialog = this.viewedDialog();
		if (viewedDialog) {
			viewedDialog.close();
		} else {
			this.dialog.close(undefined);
		}
	}
}
